import React from 'react';
import classes from './pad.module.scss';

interface PadProps {
  buttons: string[][];
  disabled: boolean;
  onPadButton: (value: string) => void;
}

const Pad = ({
  buttons,
  disabled,
  onPadButton,
}: PadProps) => {

  const renderPadButton = (item: string) => {
    return (
      <button
        className={classes.pad__button}
        onClick={() => onPadButton(item)}
        disabled={disabled}
      >
        <span className={classes.pad__button__text}>{item}</span>
      </button>
    );
  }

  return (
    <div className={classes.pad}>
      <ul className={classes.pad__list}>
        {buttons.map((row, rowIndex) => (
          <li className={classes.pad__row} key={rowIndex}>
            {row.map((cell, cellIndex) => {
              return (
                <div
                  key={`${rowIndex}-${cellIndex}`}
                  className={classes.pad__item}
                >
                  {renderPadButton(cell)}
                </div>
              );
            })}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Pad;